(function () {
  let isRendering = false;

  function formatMoney(cents) {
    const amount = cents / 100;
    const locale = document.documentElement.lang || 'fr-FR';
    const currency =
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'EUR';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2)} €`;
    }
  }

  function getBundleRows() {
    return Array.from(document.querySelectorAll('[data-moq-bundle-row="true"]'));
  }

  function groupRowsByBundle(rows) {
    return rows.reduce((groups, row) => {
      const bundleId = row.dataset.moqBundleId;

      if (!bundleId) return groups;

      if (!groups[bundleId]) {
        groups[bundleId] = [];
      }

      groups[bundleId].push(row);

      return groups;
    }, {});
  }

  function buildComponentList(rows) {
    const list = document.createElement('ul');
    list.className = 'moq-cart-bundle__components';

    rows.forEach((row) => {
      const title = row.dataset.moqComponentTitle || '';
      const quantity = row.dataset.moqComponentQuantity || '';

      if (!title || !quantity) return;

      const item = document.createElement('li');
      item.textContent = `${quantity} × ${title}`;
      list.appendChild(item);
    });

    return list;
  }

  function getBundleTotalPrice(rows) {
    return rows.reduce((total, row) => {
      const price = parseInt(row.dataset.moqLinePrice || '0', 10);
      return total + (Number.isNaN(price) ? 0 : price);
    }, 0);
  }

  function getBundleKeys(rows) {
    return rows
      .map((row) => row.dataset.moqLineKey)
      .filter(Boolean);
  }

  function renderBundleGroup(rows) {
    if (!rows.length) return;

    const masterRow = rows[0];
    const hiddenRows = rows.slice(1);
    const bundleTitle = masterRow.dataset.moqBundleTitle || 'Pack';
    const bundleId = masterRow.dataset.moqBundleId || '';
    const bundleKeys = getBundleKeys(rows);
    const totalPrice = getBundleTotalPrice(rows);

    masterRow.dataset.moqBundleMaster = 'true';

    rows.forEach((row) => {
      row.querySelectorAll('input, select, textarea').forEach((field) => {
        if (typeof field.setCustomValidity === 'function') {
          field.setCustomValidity('');
        }

        field.removeAttribute('required');
      });
    });

    hiddenRows.forEach((row) => {
      row.style.display = 'none';
      row.setAttribute('aria-hidden', 'true');
    });

    const titleElement =
      masterRow.querySelector('.cart-items__title') ||
      masterRow.querySelector('a[href*="/products/"]');

    if (titleElement) {
      titleElement.textContent = bundleTitle;
    }

    const infoContainer =
      masterRow.querySelector('.cart-items__product-info') ||
      masterRow.querySelector('.cart-items__details') ||
      masterRow.querySelector('td');

    if (infoContainer) {
      const oldSummary = infoContainer.querySelector('.moq-cart-bundle__components');

      if (oldSummary) {
        oldSummary.remove();
      }

      infoContainer.appendChild(buildComponentList(rows));
    }

    const quantityCell =
      masterRow.querySelector('.cart-items__quantity') ||
      masterRow.querySelector('[class*="quantity"]');

    if (quantityCell) {
      quantityCell.innerHTML = '';

      const wrapper = document.createElement('div');
      wrapper.className = 'moq-cart-bundle__actions';

      const text = document.createElement('span');
      text.className = 'moq-cart-bundle__locked';
      text.textContent = 'Pack verrouillé';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button moq-cart-bundle__remove';
      button.textContent = 'Supprimer le pack';
      button.setAttribute('data-moq-remove-bundle', 'true');
      button.setAttribute('data-moq-bundle-id', bundleId);
      button.setAttribute('data-moq-bundle-keys', JSON.stringify(bundleKeys));

      wrapper.appendChild(text);
      wrapper.appendChild(button);
      quantityCell.appendChild(wrapper);
    }

    const priceCell =
      masterRow.querySelector('.cart-items__price text-component') ||
      masterRow.querySelector('.cart-items__price') ||
      masterRow.querySelector('[class*="price"]');

    if (priceCell) {
      priceCell.textContent = formatMoney(totalPrice);
    }
  }

  function groupCartBundles() {
    if (isRendering) return;

    isRendering = true;

    try {
      const rows = getBundleRows();

      if (!rows.length) return;

      const groups = groupRowsByBundle(rows);

      Object.values(groups).forEach(renderBundleGroup);
    } catch (error) {
      console.error('Erreur regroupement pack :', error);
    } finally {
      isRendering = false;
    }
  }

  async function removeBundle(button) {
  const bundleId = button.getAttribute('data-moq-bundle-id') || '';

  if (!bundleId) {
    console.error('Aucun bundleId trouvé sur le bouton.');
    button.textContent = 'Erreur pack';
    return;
  }

  button.disabled = true;
  button.textContent = 'Suppression...';

  try {
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!cartResponse.ok) {
      throw new Error('Impossible de lire le panier');
    }

    const cart = await cartResponse.json();

    const linesToRemove = [];

    cart.items.forEach((item, index) => {
      const properties = item.properties || {};

      if (properties._bundle_id === bundleId) {
        linesToRemove.push(index + 1); // Shopify utilise des lignes en base 1
      }
    });

    console.log('Bundle à supprimer :', bundleId);
    console.log('Lignes à supprimer :', linesToRemove);

    if (!linesToRemove.length) {
      throw new Error('Aucune ligne trouvée pour ce pack');
    }

    // Très important : on supprime de la dernière ligne vers la première
    // pour éviter que les index changent pendant la suppression.
    linesToRemove.sort((a, b) => b - a);

    for (const line of linesToRemove) {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error(`Erreur suppression ligne ${line}`);
      }

      await response.json();
    }

    window.location.reload();
  } catch (error) {
    console.error('Erreur suppression pack :', error);
    button.disabled = false;
    button.textContent = 'Réessayer';
  }
}

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-moq-remove-bundle="true"]');

    if (!button) return;

    event.preventDefault();
    removeBundle(button);
  });

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (!form.matches('form[action*="/cart"]')) {
        return;
      }

      form.querySelectorAll('[data-moq-bundle-row="true"] input').forEach((input) => {
        if (typeof input.setCustomValidity === 'function') {
          input.setCustomValidity('');
        }

        input.removeAttribute('required');
      });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', groupCartBundles);

  const observer = new MutationObserver(function () {
    window.requestAnimationFrame(groupCartBundles);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();